export const useLoginMutation = () => {
  const login = async () => {
    // alert('Đăng nhập thành công (giả lập)!');
    return Promise.resolve();
  };
  return [login, { isLoading: false }];
};